import Divider from '@/components/common/Divider';
import useLanguage from '@/utils/hooks/useLanguage';
import Modal, { ModalClose, ModalHeader, ModalProps, ModalTitle } from '../Modal';
import CryptoWithdrawalForm from './CryptoWithdrawalForm';
import FiatWithdrawalForm from './FiatWithdrawalForm';

export interface PortalWithdrawalModalProps extends ModalProps {
    mode: 'bank' | 'crypto';
    currency?: string;
    onRefresh?: () => void;
}

const PortalWithdrawalModal = (props: PortalWithdrawalModalProps) => {
    const { handlers, mode } = props;

    const lang = useLanguage();

    return (
        <Modal {...props} className="h-auto" size="max-w-lg">
            <ModalHeader>
                <ModalTitle>
                    {mode === 'bank' ? lang.portal.withdrawalViaBankTransfer : lang.portal.withdrawalViaCryptoTransfer}
                </ModalTitle>
                <ModalClose handlers={handlers} />
            </ModalHeader>
            <Divider neutral />
            {mode === 'bank' ? <FiatWithdrawalForm {...props} /> : <CryptoWithdrawalForm {...props} />}
        </Modal>
    );
};

export default PortalWithdrawalModal;
